import { render, staticRenderFns } from "./RAssessment.vue?vue&type=template&id=6fd57088&scoped=true"
import script from "./RAssessment.vue?vue&type=script&lang=js"
export * from "./RAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd57088",
  null
  
)

export default component.exports